export default "__VITE_ASSET__TTm72e2I__"